import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Divider, IconButton, Tooltip } from "@mui/material";
import { useTheme } from "@emotion/react";
import CloseIcon from "@mui/icons-material/Close";

const ModalContainer = (props) => {
  const theme = useTheme();

  return (
    <>
      <Dialog
        open={props.show}
        maxWidth={props?.maxWidth || "sm"}
        fullWidth
        sx={props.sx || {}}
      >
        <DialogTitle style={{ padding: "16px 24px" }}>
          <Box
            className="dialog-header"
            style={{ backgroundColor: theme.palette.background.paper }}
          >
            <div className="dialog-header__title">{props?.title}</div>

            <Tooltip title="Close" placement="bottom">
              <IconButton onClick={props?.onClose}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent>{props.children}</DialogContent>
      </Dialog>
    </>
  );
};

export default ModalContainer;
